import { render, staticRenderFns } from "./RelatoriosManutencao.vue?vue&type=template&id=217b2faf&scoped=true&"
import script from "./RelatoriosManutencao.vue?vue&type=script&lang=js&"
export * from "./RelatoriosManutencao.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosManutencao.vue?vue&type=style&index=0&id=217b2faf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217b2faf",
  null
  
)

export default component.exports